import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import Check from './scenes/View/components/Check';

const App = () => (
  <Router>
    <Route exact path="/check/:uuid" component={Check} />
  </Router>
);

export default App;
